<template>
  <with-actions v-if="$store.state.currentOrganization">
    <step-navigation
      class="dark-gray"
      v-model="customer"
      v-on="$listeners"
      v-on:submit="save($event)"
      :submit_text="$t(is_edit ? 'save' : 'create')"
      :steps="is_edit ? steps.filter((s) => s.is_edit) : steps"
      :step_prefix="step_prefix"
      :allow_deep_link="true"
      :customer_types="customer_types"
    ></step-navigation>
  </with-actions>
</template>
<script>
import { mapState } from 'vuex';
import store from '@/store';
import { handle } from '@/utils/alerts';
import Api from '@/store/jsonapi';

export default {
  props: {
    value: {
      type: Object,
      required: true
    },
    is_edit: {
      type: Boolean,
      required: true
    }
  },
  data: function () {
    return {
      step_prefix: 'customer-creation-',
      steps: [
        {
          label: 'Company data',
          component: 'company',
          is_edit: true
        },
        // TODO: Include once sales need to add custom videos to each customer
        // {
        //     label: 'Welcome video',
        //     component: 'video',
        //     is_edit: false
        // },
        {
          // Enable again!
          label: 'Integrations',
          component: 'integrations',
          is_edit: false
        },
        {
          label: 'Quote',
          component: 'quote',
          is_edit: false
        }
      ],
      step: null,
      currentStep: 0,
      customer_types: ['active', 'blocked', 'cancelled', 'test', 'migrating', 'onboarding']
    };
  },
  computed: {
    ...mapState(['currentOrganization']),
    customer() {
      return this.value;
    }
  },
  methods: {
    save: handle(async function (event) {
      this.$emit('save', event);
    })
  }
};
</script>

<style lang="scss">
.dark-gray {
  color: dimgray;
}
</style>
